import React, { JSX } from "react";
import { ButtonSize } from "../../../../components/Button";
import { Button } from "../../../../components/Button";
import { OPAAvatar } from "../../../../components/OPAAvatar";
import { ButtonVariant } from "../../../../config/colors";
import { useRouter } from "../../../../hooks/useRouter";
import { PaymentType, Transaction } from "../../../../models/Transactions";
import { useLocation } from "react-router-dom";
import { SendTransactionStateRecipient } from "../SendTransaction";
import { BulkTypes } from "../../../../models/BulkPayment";
import { ChatChannelType } from "../../../../models/ChatChannel";
import { formatAmount } from "../../../../utils/Utils";

const buttonSize = ButtonSize.mediumSmall;

const ButtonsInfosTxSenderReceiver = ({transaction, recipient, clickable = true}: {transaction?: Transaction, recipient?: SendTransactionStateRecipient, clickable?: boolean}) => {
    const {navigateToUserProfile, navigateFromChannelTypeAndId} = useRouter();
    const location = useLocation();

    let isSend: boolean = true;
    let internalUserSender: any = null;
    let internalUserReceipient: any = null;
    let lnurlRecipient: any = null;
    let invoiceRecipient: any = null;
    let bulkPaymentRecipient: JSX.Element | string | null = null;
    let fromBulkRecipient: any = null;

    if(transaction)
    {
        isSend = transaction?.amount < 0;

        if(transaction?.type === PaymentType.bulk) {
            if(transaction.bulk?.name) {
                if(transaction.bulk?.type === BulkTypes.distanceFromMyself) {
                    bulkPaymentRecipient = <span>
                        <span>{formatAmount(transaction.bulk?.nbToSend ?? 0)} people within {transaction.bulk?.name} </span>
                    </span>
                } else {
                    bulkPaymentRecipient = <span>
                        <span>{formatAmount(transaction.bulk?.nbToSend ?? 0)} people in {transaction.bulk?.name} </span>
                    </span>
                }
            }
        }
            
        else if(transaction?.sender && transaction.sender.internalUser)
            internalUserSender = transaction.sender.internalUser;
        else if(transaction?.recipient && transaction.recipient.internalUser && transaction?.isInternal !== false)
            internalUserReceipient = transaction.recipient.internalUser;
        else if(transaction?.recipient && transaction.recipient.lnurl)
            lnurlRecipient = transaction.recipient.lnurl;
        else if(transaction?.recipient && transaction.recipient.invoice)
            invoiceRecipient = transaction.recipient.invoice;

        if(transaction?.fromBulk)
            fromBulkRecipient = transaction.fromBulk ?? null;
    }
    else if(recipient)
    {
        if(recipient.pleb)
        {
            if(recipient.pleb.shouldShowNameAndPicture())
                internalUserReceipient = recipient.pleb;
            else
                lnurlRecipient = recipient.pleb.getLnUrlToPayTo();
        }
        else if(recipient.lnurl)
            lnurlRecipient = recipient.lnurl;
        else if(recipient.invoice)
            invoiceRecipient = recipient.invoice;
        else if(recipient.bulkPayment)
            bulkPaymentRecipient = recipient.bulkPayment.getDisplayName();
    }

    return (
        <>
            {
                !isSend && internalUserSender && (
                <Button
                    size={buttonSize}
                    variant={ButtonVariant.primary}
                    onClick={() => clickable && navigateToUserProfile(internalUserSender?.id ?? '', location.pathname)}
                    className="py-1.5 rounded-2xl"
                    type="button"
                >
                    {internalUserSender.name}
                    <OPAAvatar
                        imageUrl={internalUserSender.image}
                        size={30}
                        borderWidth={1}
                        borderColor="var(--brand-white)"
                    />
                </Button>
            )
        }

        {
            isSend && lnurlRecipient && (
                <Button
                    size={buttonSize}
                    variant={ButtonVariant.primary}
                    className="py-1.5 rounded-2xl"
                    type="button"
                >
                    {lnurlRecipient}
                </Button>
            )
        }

        {
            isSend && invoiceRecipient && (
                <Button
                    size={buttonSize}
                    variant={ButtonVariant.primary}
                    className="py-1.5 rounded-2xl"
                    type="button"
                    title={invoiceRecipient}
                >
                    {invoiceRecipient.slice(0, 8)}...{invoiceRecipient.slice(-8)}
                </Button>
            )
        }

        {
            bulkPaymentRecipient && (
                <Button
                    size={buttonSize}
                    variant={ButtonVariant.primary}
                    className="py-1.5 rounded-2xl"
                    type="button"
                >
                    <span>{bulkPaymentRecipient}</span>
                </Button>
            )
        }

        {
            isSend && internalUserReceipient && (
                <Button
                    size={buttonSize}
                    variant={ButtonVariant.primary}
                    onClick={() => clickable && navigateToUserProfile(internalUserReceipient?.id ?? '', location.pathname)}
                    className="py-1.5 rounded-2xl"
                    type="button"
                >
                    {internalUserReceipient.name}
                    <OPAAvatar
                        imageUrl={internalUserReceipient.image}
                        size={30}
                        borderWidth={1}
                        borderColor="var(--brand-white)"
                    />
                </Button>
            )
        }

        {
            fromBulkRecipient !== null && (
                <Button
                    size={buttonSize}
                    variant={ButtonVariant.primary}
                    className="py-1.5 rounded-2xl"
                    type="button"
                    onClick={() => {
                        if(clickable)
                        {
                            if(fromBulkRecipient.type === BulkTypes.group)
                                navigateFromChannelTypeAndId(ChatChannelType.Group, fromBulkRecipient.id);
                            else if(fromBulkRecipient.type === BulkTypes.event)
                                navigateFromChannelTypeAndId(ChatChannelType.Event, fromBulkRecipient.id);
                        }
                    }}
                >
                    {fromBulkRecipient.name}
                </Button>
            )
        }
        </>
    )
}

export default ButtonsInfosTxSenderReceiver;